import { ColumnsType } from 'antd/lib/table'
import ColorProofNumber from '../../../../../../../components/color-proof-number/color-proof-number'
import { renderShipmentCalculatedValue } from '../../../../../../../components/shipment-calculated-value/render-shipment-calculated-value'
import formatDuration from '../../../../../../../helpers/date-time/format-duration'
import renderDate from '../../../../../../../helpers/tables/render-date'
import { MaterialRequirement } from '../../../../../../../types/api/components/material/material-requirements'
import PrintQueueEntry from '../../../../../../../types/api/print-queue-entry'
import ShipmentPosition from '../../../../../../../types/api/shipment-position'
import { createAvailabilityColumns } from '../../../../constants/availability-columns'
import {
    createStampTubeColumn,
    printQueueFormSetIdColumn,
    createAdditionalJobsColumn,
    createAdditionalInfoColumn,
    createCuratorPrintColumn,
} from '../../../../constants/columns'
import { MaterialColumnCell } from '../../../cells/material-column-cell'
import TsAndLm from '../../../cells/ts-and-lm'
import ActionsCell from './actions-cell'
import PrintJobNoteCell from '../../../cells/print-job-note-cell'
import { formatRollerDisplay } from '../../../../../../../helpers/format-roller-display'
import { RotatedTitle } from '../../../../../../../components/rotated-title/rotated-title'

export const getColumns = (canEdit: boolean): ColumnsType<PrintQueueEntry> => [
    {
        dataIndex: 'id',
        title: 'Номер в очереди',
        width: 68,
        render: (id, record: PrintQueueEntry) => (
            <ColorProofNumber shipmentType={record.print_job?.shipment?.shipmentType}>
                {id}
            </ColorProofNumber>
        ),
    },
    {
        dataIndex: ['print_job', 'shipment', 'clientDeliveryDate'],
        title: 'Дата поставки',
        width: 70,
        render: renderDate,
    },
    { dataIndex: ['print_job', 'shipment', 'client', 'name'], title: 'Клиент' },
    createAdditionalInfoColumn<PrintQueueEntry>(record => record.print_job?.shipment),
    {
        dataIndex: ['print_job', 'shipment', 'shipment_positions'],
        title: 'Тираж',
        render(v: ShipmentPosition[]) {
            return (v ?? []).reduce((acc, v) => acc + (v?.copies ?? 0), 0)
        },
    },
    {
        dataIndex: ['print_job', 'shipment', 'materialRequirements'],
        title: 'Материал',
        width: 100,
        render(v: MaterialRequirement[], record) {
            return <MaterialColumnCell value={v} shipment={record.print_job?.shipment} />
        },
    },
    {
        dataIndex: ['print_job', 'shipment', 'materialRequirements'],
        title: 'ТС / ЛМ',
        width: 60,
        render(v: MaterialRequirement[]) {
            return <TsAndLm materialRequirements={v} />
        },
    },
    createCuratorPrintColumn<PrintQueueEntry>(record => record.print_job?.shipment),
    {
        dataIndex: ['print_job', 'shipment', 'calculated', 'materialLength'],
        title: 'Метраж',
        width: 60,
        render(_v, r: PrintQueueEntry) {
            return renderShipmentCalculatedValue(r.print_job?.shipment, calculated =>
                Math.round((calculated?.materialLength || 0) * 1000) / 1000
            )
        },
    },
    printQueueFormSetIdColumn,
    createStampTubeColumn<PrintQueueEntry>(record => record.print_job?.shipment),
    {
        dataIndex: ['print_job', 'shipment', 'stamp', 'roller', 'roller'],
        title: 'Вал',
        render: (v: number) => formatRollerDisplay(v),
    },
    createAdditionalJobsColumn(['print_job', 'shipment']),
    createAvailabilityColumns<PrintQueueEntry>(record => record.print_job?.shipment),
    // TODO: рассчитываемое поле, добавить
    {
        dataIndex: ['print_job', 'shipment', 'calculated', 'commonTime'],
        title: <RotatedTitle>Время тиража</RotatedTitle>,
        width: 56,
        render(_v, r: PrintQueueEntry) {
            return renderShipmentCalculatedValue(r.print_job?.shipment, calculated =>
                formatDuration(calculated?.commonTime || 0)
            )
        },
    },
    {
        title: 'Примечание',
        width: 140,
        render(_, record) {
            return <PrintJobNoteCell printJob={record.print_job!} editable={canEdit} />
        },
    },
    {
        dataIndex: 'actions',
        title: '',
        fixed: 'right',
        render(v, r) {
            return <ActionsCell printQueueEntry={r} />
        },
    },
]
